import djangoFetch, { formDataToJson } from '../fetch/djangoFetch';
import togglePasswordFieldType from '../../toggle-password-field-type';

class AjaxForm {
  constructor(elements) {
    this.elements = elements;
    this.handlers = {
      onSubmit: (event) => {
        event.preventDefault();
        this.post();
      },
    };
    this.init();
  }

  init() {
    this.elements.submit_button = this.elements.form.querySelector('[type="submit"]');
    this.elements.response_container = this.elements.form.querySelector('#modalResponseContainer');
    this.elements.form.addEventListener('submit', this.handlers.onSubmit);
    this.initWidgets();
  }

  unInit() {
    this.elements.form.removeEventListener('submit', this.handlers.onSubmit);
    this.uninitWidgets();
  }

  initWidgets(data) {}

  uninitWidgets() {}

  showError() {}

  getFormData() {
    return new FormData(this.elements.form);
  }

  getJSONFormData() {
    return formDataToJson(this.getFormData());
  }

  post() {
    this.showLoading();
    djangoFetch(this.elements.form.getAttribute('action'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(this.getJSONFormData()),
    }).then(response => {
      this.hideLoading();
      if (response.ok) {
        if (response.headers.get('Content-Type') === 'application/json') {
          return response.json();
        } else if (response.headers.get('Content-Type') === 'text/html') {
          return response.text();
        }
      } else {
        throw Error(`Error, http code: ${response.status}`);
      }
    }).
      then(responseContent => {
        this.parseResponse(responseContent);
        if (this.elements.form.getAttribute('data-next') === 'true'){
          if (responseContent.error && this.elements.response_container) {
            this.elements.response_container.innerHTML = responseContent.html;
          } else {
            this.elements.form.innerHTML = responseContent.html;
          }
        }

        if (responseContent.error) {
          togglePasswordFieldType(this.elements.form.querySelectorAll('.passwordInputField__Wrapper'));
        }
      }).
      catch(error => {
        this.hideLoading();
        this.showError(error.message);
      });
  }

  parseResponse(responseData) {}

  showLoading() {}

  hideLoading() {}
}

export default AjaxForm;



// WEBPACK FOOTER //
// ./src/js/lib/forms/AjaxForm.js